import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
    { label: "Manifesto", href: "#manifesto" },
    { label: "Playbook", href: "#playbook" },
    { label: "Pricing", href: "#pricing" },
    { label: "FAQ", href: "#faq" },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 30);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <motion.nav
            data-testid="landing-nav"
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.15, duration: 0.9, ease: [0.2, 0.9, 0.2, 1] }}
            className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
                scrolled
                    ? "bg-[#050505]/90 backdrop-blur-md border-b border-white/5"
                    : "bg-transparent"
            }`}
        >
            <div className="container-x flex items-center justify-between h-16 md:h-20">
                <a
                    href="#top"
                    data-testid="nav-logo"
                    className="flex items-center gap-2 group"
                >
                    <span className="w-2 h-2 bg-[#e84125] block" />
                    <span className="font-mono uppercase text-[0.72rem] tracking-[0.24em] text-white">
                        VDL / <span className="text-white/50">Dual-Engine</span>
                    </span>
                </a>
                <ul className="hidden md:flex items-center gap-8">
                    {links.map((l) => (
                        <li key={l.href}>
                            <a
                                href={l.href}
                                data-testid={`nav-link-${l.label.toLowerCase()}`}
                                className="font-mono uppercase text-[0.7rem] tracking-[0.22em] text-white/70 hover-underline"
                            >
                                {l.label}
                            </a>
                        </li>
                    ))}
                </ul>
                <a
                    href="#contact"
                    data-testid="nav-cta-book-call"
                    className="btn-primary hidden sm:inline-flex"
                >
                    Book a call →
                </a>
            </div>
        </motion.nav>
    );
}
